import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import { ReportTags } from "./ReportTags";
import type { ReportDateRange } from "./_models/Report";
import type { DispatchReportRangeItemDto } from "@/api/dtos";
import type { DispatchReportRangeItem } from "./_models/DispatchReport";
import { toDispatchReportRangeItemFromDto } from "./_transformers/toDispatchReportRangeItemFromDto";

/**
 * Every dispatch report whose SFTP modify time falls within [from, to], combined (each row tagged with its sourceFile).
 * A bare date (YYYY-MM-DD) expands to the whole Sydney day.
 */
export const getDispatchReportRangeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDispatchReportRange: builder.query<DispatchReportRangeItem[], ReportDateRange>({
      queryFn: async (range) => {
        try {
          const res = await axios.get<DispatchReportRangeItemDto[]>(
            `${backendBase()}/dispatch-reports/combined`,
            {
              params: { from: range.from, to: range.to },
              headers: { Accept: "application/json" },
            },
          );
          const rows = res.data.map((x) => toDispatchReportRangeItemFromDto(x));
          return { data: rows };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
      providesTags: [{ type: ReportTags.DispatchReport, id: "RANGE" }],
    }),
  }),
});

export const getDispatchReportRange = getDispatchReportRangeApi.endpoints.getDispatchReportRange;
